import React, { useEffect, useState } from "react";
import "./styles/DisclaimerModal.css";

type Props = {
    isOpen: boolean;
    onAccept: () => void;
    onDecline: () => void;
};

const DisclaimerModal: React.FC<Props> = ({ isOpen, onAccept, onDecline }) => {
    const [html, setHtml] = useState("");

    useEffect(() => {
        if (!isOpen) return;

        fetch(`${process.env.PUBLIC_URL}/disclaimer.html`)
            .then(async (r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                setHtml(await r.text());
            })
            .catch((err) => {
                console.error("Failed to load disclaimer:", err);
                setHtml("<p>Disclaimer content not available.</p>");
            });
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="disc-backdrop">
            <div className="disc-modal">
                <h2 className="disc-title">Disclaimer</h2>

                <div
                    className="disc-body"
                    dangerouslySetInnerHTML={{ __html: html }}
                />

                <div className="disc-footer">
                    <button className="disc-btn disc-btn-secondary" onClick={onDecline}>
                        Decline
                    </button>
                    <button className="disc-btn disc-btn-primary" onClick={onAccept}>
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerModal;
